export enum ADV_CLASS_TYPE {
    owner = 'OWNER',
    commissar = 'COMMISSIONER'
}